import React from "react";
import Dialog from "@mui/material/Dialog";
import DialogTitle from "@mui/material/DialogTitle";
import DialogContent from "@mui/material/DialogContent";
import DialogContentText from "@mui/material/DialogContentText";
import DialogActions from "@mui/material/DialogActions";
import Button from "@mui/material/Button";

const DeleteConfirmationDialog = ({
  isOpen,
  selectedAfm,
  signers,
  newSigners,
  setSigners,
  setNewSigners,
  setSelectedAfm,
  setDeletedAfms,
  setDeleteDialogOpen,
}) => {
  const handleDeleteConfirm = () => {
    const new_signer_index = newSigners.findIndex(
      (signer) => signer.afm === selectedAfm,
    );
    if (new_signer_index === -1) {
      setDeletedAfms((prevIds) => {
        const newIds = [...prevIds, selectedAfm];
        return newIds;
      });
      setSigners((prevSigners) =>
        prevSigners.map((signer) =>
          signer.afm === selectedAfm ? { ...signer, isDeleted: true } : signer,
        ),
      );
    } else {
      // deleting from newSigners
      const _newSigners = [...newSigners];
      _newSigners.splice(new_signer_index, 1);
      setNewSigners(_newSigners);

      // deleting from signers
      const signer_index = signers.findIndex(
        (signer) => signer.afm === selectedAfm,
      );

      if (signer_index > -1) {
        const _signers = [...signers];
        _signers.splice(signer_index, 1);
        setSigners(_signers);
      }
    }

    setDeleteDialogOpen(false);
  };

  const handleDeleteCancel = () => {
    setSelectedAfm(null);
    setDeletedAfms([]);
    setDeleteDialogOpen(false);
  };

  return (
    <Dialog open={isOpen} onClose={handleDeleteCancel}>
      <DialogTitle>Επιβεβαίωση Διαγραφής</DialogTitle>
      <DialogContent>
        <DialogContentText>
          Είστε σίγουρος ότι θέλετε να διαγράψετε αυτόν τον Υπογράφοντα;
        </DialogContentText>
      </DialogContent>
      <DialogActions>
        <Button onClick={handleDeleteCancel}>Ακύρωση</Button>
        <Button onClick={handleDeleteConfirm} autoFocus color="error">
          Διαγραφή
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default DeleteConfirmationDialog;
